import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
  getAcountingServices,
  getAgentPrehlad,
  getDruzstvoPrehlad,
  getLegalCounseling,
  getNezivotne,
  getPerzistencia,
  getUvery,
  getZivotne,
} from 'app/api/performanceApi';
import { TabPanel, TabView } from 'primereact/tabview';
import { ProgressSpinner } from 'primereact/progressspinner';
import './performance-page.css';
import { Button } from 'primereact/button';
import { ToastContext } from 'app/context/ToastContext';

const tabs = [
  {
    title: 'Prehľad',
    id: 1,
    meta: [
      {
        header: 'Celková produkcia',
        xLabels: ['Netto J', 'Brutto J'],
        yLabels: ['Vlastná produkcia', 'Skupinová produkcia', 'Celková produkcia'],
        paths: [
          ['ownNetto.units', 'ownBrutto.units'],
          ['groupNetto.units', 'groupBrutto.units'],
          ['sumNetto.units', 'sumBrutto.units'],
        ],
      },
    ],
  },
  {
    title: 'Družstvo',
    id: 2,
    meta: [
      {
        header: '',
        xLabels: ['AP', 'J', 'ks'],
        yLabels: ['Vlastná produkcia', 'Celková produkcia'],
        paths: [
          ['ownBrutto.ap', 'ownBrutto.units', 'ownBrutto.quantity'],
          ['sumBrutto.ap', 'sumBrutto.units', 'sumBrutto.quantity'],
        ],
      },
    ],
  },
  {
    title: 'Životné',
    id: 3,
    meta: [
      {
        header: 'Vlastná produkcia',
        xLabels: ['AP', 'J', 'ks'],
        yLabels: ['Brutto', 'Netto', 'Storno'],
        paths: [
          ['ownBrutto.ap', 'ownBrutto.units', 'ownBrutto.quantity'],
          ['ownNetto.ap', 'ownNetto.units', 'ownNetto.quantity'],
          ['ownStorno.ap', 'ownStorno.units', 'ownStorno.quantity'],
        ],
      },
      {
        header: 'Skupinová produkcia',
        xLabels: ['AP', 'J', 'ks'],
        yLabels: ['Brutto', 'Netto', 'Storno'],
        paths: [
          ['sumBrutto.ap', 'sumBrutto.units', 'sumBrutto.quantity'],
          ['sumNetto.ap', 'sumNetto.units', 'sumNetto.quantity'],
          ['sumStorno.ap', 'sumStorno.units', 'sumStorno.quantity'],
        ],
      },
    ],
  },
  {
    title: 'Neživotné',
    id: 4,
    meta: [
      {
        header: '',
        xLabels: ['AP', 'J', 'ks'],
        yLabels: ['Vlastná produkcia', 'Celková produkcia'],
        paths: [
          ['ownBrutto.ap', 'ownBrutto.units', 'ownBrutto.quantity'],
          ['sumBrutto.ap', 'sumBrutto.units', 'sumBrutto.quantity'],
        ],
      },
    ],
  },
  {
    title: 'Úvery',
    id: 5,
    meta: [
      {
        header: '',
        xLabels: ['AP', 'J', 'ks'],
        yLabels: ['Vlastná produkcia', 'Celková produkcia'],
        paths: [
          ['ownBrutto.ap', 'ownBrutto.units', 'ownBrutto.quantity'],
          ['sumBrutto.ap', 'sumBrutto.units', 'sumBrutto.quantity'],
        ],
      },
    ],
  },
  {
    title: 'Legal Counseling',
    id: 6,
    meta: [
      {
        header: '',
        xLabels: ['AP', 'J', 'ks'],
        yLabels: ['Vlastná produkcia', 'Celková produkcia'],
        paths: [
          ['ownBrutto.ap', 'ownBrutto.units', 'ownBrutto.quantity'],
          ['sumBrutto.ap', 'sumBrutto.units', 'sumBrutto.quantity'],
        ],
      },
    ],
  },
  {
    title: 'Acounting Services',
    id: 7,
    meta: [
      {
        header: '',
        xLabels: ['AP', 'J', 'ks'],
        yLabels: ['Vlastná produkcia', 'Celková produkcia'],
        paths: [
          ['ownBrutto.ap', 'ownBrutto.units', 'ownBrutto.quantity'],
          ['sumBrutto.ap', 'sumBrutto.units', 'sumBrutto.quantity'],
        ],
      },
    ],
  },
  {
    title: 'Perzistencia',
    id: 8,
    meta: [
      {
        header: 'Produkcia',
        xLabels: ['AP Brutto', 'AP Netto', 'AP Storno', ''],
        yLabels: ['Vlastná produkcia', 'Skupinová produkcia', 'Celková produkcia'],
        paths: [
          ['ownBrutto.ap', 'ownNetto.ap', 'ownStorno.ap', 'ownCnt.ap'],
          ['groupBrutto.ap', 'groupNetto.ap', 'groupStorno.ap', 'groupCnt.ap'],
          ['sumBrutto.ap', 'sumNetto.ap', 'sumStorno.ap', 'sumCnt.ap'],
        ],
      },
    ],
  },
];

const PerformancePage = () => {
  const { id } = useParams<{ id?: string }>(); // Capture id from URL
  const { showError } = useContext(ToastContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [tabData, setTabData] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [searchParamsInitial] = useSearchParams();
  const tempParameters = searchParamsInitial.get('p');

  const fetchData = tabId => {
    setLoading(true);

    let call;

    if (tabId === 1) {
      call = getAgentPrehlad(id);
    } else if (tabId === 2) {
      call = getDruzstvoPrehlad(id);
    } else if (tabId === 3) {
      call = getZivotne(id);
    } else if (tabId === 4) {
      call = getNezivotne(id);
    } else if (tabId === 5) {
      call = getUvery(id);
    } else if (tabId === 6) {
      call = getLegalCounseling(id);
    } else if (tabId === 7) {
      call = getAcountingServices(id);
    } else if (tabId === 8) {
      call = getPerzistencia(id);
    }

    call
      .then(response => {
        setTabData(prevData => ({ ...prevData, [tabId]: response.data }));
      })
      .catch(e => {
        console.error('Chyba pri načítaní výkonov:', e);
        showError('Chyba', 'Nastala chyba pri načítaní výkonov.');
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData(tabs[0].id);
  }, []);

  const onTabChange = e => {
    setActiveIndex(e.index);
    const selectedTabId = tabs[e.index].id;

    // If data for the selected tab hasn't been loaded yet, fetch it
    if (!tabData[selectedTabId]) {
      fetchData(selectedTabId);
    }
  };

  const convertStringToNumber = nr => {
    if (nr) {
      return nr.toLocaleString('sk-SK', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    return undefined;
  };

  function getValueByPath(obj, path) {
    return convertStringToNumber(
      path.split('.').reduce((acc, key) => {
        return acc && acc[key] !== undefined ? acc[key] : undefined;
      }, obj),
    );
  }

  const renderTable = (data, defs) => {
    const { xLabels, yLabels, paths, header } = defs;

    return (
      <table className="custom-table">
        <thead>
          <tr>
            <th colSpan={xLabels.length + 1} className="top-header">
              {header}
            </th>
          </tr>
          <tr>
            <th></th>
            {xLabels.map(label => (
              <th key={label}>{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {yLabels.map((yLabel, rowIndex) => (
            <tr key={yLabel}>
              <td className="yTh">
                <b>{yLabel}</b>
              </td>
              {paths[rowIndex].map((cell, cellIndex) => (
                <td key={cellIndex}>{getValueByPath(data, cell)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div className="card">
      <TabView activeIndex={activeIndex} onTabChange={onTabChange}>
        {tabs.map((tab, index) => (
          <TabPanel header={tab.title} key={tab.id + 'tab'}>
            {loading && activeIndex === index ? (
              <div key={index + '-div'} className="p-d-flex p-jc-center p-ai-center" style={{ height: '200px', justifyItems: 'center' }}>
                <ProgressSpinner key={index + '-progress'} />
              </div>
            ) : (
              <div>
                {/* Display the loaded data */}
                {tabData[tab.id] ? (
                  <div>
                    <h2>
                      {tabData[tab.id]?.agentDTO?.firstName} {tabData[tab.id]?.agentDTO?.lastName} {tabData[tab.id]?.agentDTO?.name}
                    </h2>
                    <p>Počet nezahrnutých zmlúv prepočítaných na jednotky: {tabData[tab.id]?.nrOfNotIncludedContracts ?? 0}</p>
                    {tab.meta.map(meta => renderTable(tabData[tab.id], meta))}
                  </div>
                ) : (
                  <div>
                    <p>Nie sú k dispozícií žiadne dáta.</p>
                  </div>
                )}
              </div>
            )}
          </TabPanel>
        ))}
      </TabView>
      <Button
        type="button"
        style={{ backgroundColor: 'gray', marginTop: '10px' }}
        label="Naspäť"
        icon="pi pi-arrow-left"
        className="p-button-secondary"
        onClick={() => navigate(`/agents?p=${tempParameters}`)}
      />
    </div>
  );
};

export default PerformancePage;
